import { Dialog, dialogClasses } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BlueRoundedButton } from '../../common/components/BlueRoundedButton';

import { StatusDiagram } from './StatusDiagram';

interface MobileRequestStatusDescriptionModalProps {
  open: boolean;
  onClose?: () => void;
}
export const MobileRequestStatusDescriptionModal = (
  props: MobileRequestStatusDescriptionModalProps,
) => {
  const { open, onClose } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.requestedImages.diagram',
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        [`& .${dialogClasses.paper}`]: {
          height: '400px',
          padding: '10px',
        },
      }}>
      <StatusDiagram />
      <BlueRoundedButton marginTop="50px" onClick={onClose}>
        {t('close')}
      </BlueRoundedButton>
    </Dialog>
  );
};
